import {Injectable} from '@angular/core';

import {Storage} from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private _storage: Storage | null = null;
  private _initPromise: Promise<Storage> | null = null;

  constructor(private storage: Storage) {
    this._initPromise = this.init();
  }

  async init(): Promise<Storage> {
    const storage = await this.storage.create();
    this._storage = storage;
    return storage;
  }

  // Ensure storage is initialized before any operation
  private async ensureInitialized(): Promise<Storage> {
    if (this._storage) {
      return this._storage;
    }
    if (this._initPromise) {
      return this._initPromise;
    }
    return this.init();
  }

  public async set(key: string, value: any) {
    const storage = await this.ensureInitialized();
    return storage.set(key, value);
  }

  public async get(key: string) {
    const storage = await this.ensureInitialized();
    return storage.get(key);
  }

  public async remove(key: string) {
    const storage = await this.ensureInitialized();
    return storage.remove(key);
  }
}
